import { render, staticRenderFns } from "./TermsRegular.vue?vue&type=template&id=26ae4edc&scoped=true"
import script from "./TermsRegular.vue?vue&type=script&lang=js"
export * from "./TermsRegular.vue?vue&type=script&lang=js"
import style0 from "./TermsRegular.vue?vue&type=style&index=0&id=26ae4edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ae4edc",
  null
  
)

export default component.exports